import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { IonicPageModule } from "ionic-angular";
import { NavigationModule } from "navigation/navigation.module";
import { TermsConditions } from "./terms-conditions";
@NgModule({
  declarations: [TermsConditions],
  imports: [
    IonicPageModule.forChild(TermsConditions),
    TranslateModule.forChild(),
    NavigationModule,
    CommonComponentsModule,
  ],
  entryComponents: [TermsConditions],
  exports: [TermsConditions],
})
export class TermsConditionsModule {}



// WEBPACK FOOTER //
// ./src/pages/common/cognito/terms-conditions/terms-conditions.module.ts